module.exports = __webpack_public_path__ + "img/microsoft-sql-server.acaee436.png";